import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=20687150&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=20687150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20687150",
  null
  
)

export default component.exports